/**
 * Common styles for UI components
 */

// Search input styles
export const searchInputStyles = {
  desktop: {
    paper: {
      p: '2px 4px',
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #ddd',
      borderRadius: 2,
      boxShadow: 'none',
      width: '100%'
    },
    input: {
      ml: 1,
      flex: 1,
      fontSize: 16
    }
  },
  mobile: {
    paper: {
      p: '2px 8px',
      display: 'flex',
      alignItems: 'center',
      borderRadius: 2,
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      backgroundColor: '#fff',
      position: 'relative'
    },
    input: {
      ml: 1, 
      flex: 1,
      fontSize: '0.95rem',
      padding: '6px 0'
    }
  },
  drawer: {
    paper: {
      p: '2px 4px',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      border: '1px solid #ddd',
      borderRadius: 2
    },
    input: {
      ml: 1,
      flex: 1,
      fontSize: '0.9rem',
      padding: '6px 0'
    }
  }
};

// Header styles
export const headerStyles = {
  topBar: {
    backgroundColor: 'background.default',
    borderTop: '2px solid primary.main',
    borderBottom: '1px solid #e0e0e0'
  },
  mainBar: {
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderBottom: '1px solid #e0e0e0'
  },
  mobileBar: {
    backgroundColor: '#222',
    py: 1
  },
  menuBar: {
    backgroundColor: 'secondary.main',
    boxShadow: 'none',
    borderBottom: '2px solid primary.main'
  }
};

// Button and icon styles
export const iconButtonStyles = {
  search: {
    p: '10px'
  },
  mobileSearch: {
    p: '8px'
  }
};

// Common drawer styles
export const drawerStyles = {
  mobileSidebar: {
    width: '80%',
    maxWidth: 320,
    bgcolor: 'background.paper'
  },
  debugDrawer: {
    width: 600,
    p: 3
  }
};
